import { motion } from 'motion/react';
import { Link } from 'react-router';

export default function CustomerAgreement() {
  return (
    <div className="h-full overflow-y-auto bg-white">
      <div className="mx-auto max-w-4xl px-4 py-8 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="mb-8 flex justify-start">
            <Link to="/" aria-label="MedHub">
              <img
                src="/images/HospitalLogo.png"
                alt="MedHub"
                width={1280}
                height={1280}
                className="h-24 w-auto object-contain"
              />
            </Link>
          </div>

          <section dir="rtl" className="mb-16">
            <h1 className="mb-8 text-2xl font-bold text-gray-900">
              اتفاقية اشتراك العميل في المنصة
            </h1>

            <div className="space-y-8">
              <div>
                <p className="mb-4 leading-relaxed text-gray-600">
                  بعون الله تعالى أُبرمت هذه الاتفاقية بين كل من:
                </p>
                <p className="mb-2 leading-relaxed text-gray-600">
                  <strong>الطرف الأول:</strong> منصة ميد هب (MedHub). ويشار
                  إليها فيما بعد بـ ("الطرف الأول").
                </p>
                <p className="mb-2 leading-relaxed text-gray-600">
                  <strong>الطرف الثاني:</strong> العميل الذي يقوم بإنشاء حساب في
                  المنصة والموافقة على هذه الاتفاقية إلكترونياً. ويشار إليه فيما
                  بعد بـ ("الطرف الثاني").
                </p>
                <p className="leading-relaxed text-gray-600">
                  (ويشار إليهما مجتمعين فيما بعد بـ "الطرفين" أو "الطرفان"
                  ومنفردين بـ "الطرف" أو "طرف").
                </p>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  التعريفات
                </h2>
                <p className="mb-4 leading-relaxed text-gray-600">
                  يكون للعبارات والمصطلحات الواردة في هذه الاتفاقية المعاني
                  الموضحة أمام كل منها ما لم يقتض السياق خلاف ذلك:
                </p>
                <ul className="list-disc space-y-3 pr-6 text-gray-600">
                  <li>
                    <strong>الاتفاقية:</strong> هذه الاتفاقية وكافة الجداول
                    والملاحق المرفقة بها.
                  </li>
                  <li>
                    <strong>المنصة:</strong> منصة ميد هب (MedHub)، وهي منصة
                    إلكترونية تتيح للعملاء طلب الخدمات الإسعافية وما يرتبط بها
                    من الجهات المشتركة.
                  </li>
                  <li>
                    <strong>العملاء:</strong> هم الجهات أو الأشخاص المستفيدون من
                    المنصة والذين يقدمون طلب الخدمة من خلالها.
                  </li>
                  <li>
                    <strong>الجهات المشتركة:</strong> هو مزود الخدمة المشترك في
                    المنصة لتقديم خدماته من خلالها.
                  </li>
                </ul>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  التمهيد
                </h2>
                <p className="mb-4 leading-relaxed text-gray-600">
                  حيث يعمل الطرف الأول في مجال الحلول والخدمات الصحية والرقمية،
                  وحيث يملك الطرف الأول المنصة، والمتخصصة بعرض الخدمات الإسعافية
                  وما يرتبط بها للعملاء.
                </p>
                <p className="leading-relaxed text-gray-600">
                  وحيث رغب الطرف الثاني بالاشتراك في المنصة لطلب خدمات الجهات
                  المشتركة، فقد اتفق الطرفان على إبرام هذه الاتفاقية وفق ما يلي:
                </p>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  المادة الأولى: حكم التمهيد
                </h2>
                <p className="leading-relaxed text-gray-600">
                  يعد التمهيد السابق جزءاً لا يتجزأ من هذه الاتفاقية ويقرأ ويفسر
                  معها.
                </p>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  المادة الثانية: الهدف من الاتفاقية
                </h2>
                <p className="leading-relaxed text-gray-600">
                  تهدف هذه الاتفاقية لتمكين الطرف الثاني من التسجيل في المنصة
                  كعميل ليتمكن من طلب خدمات الجهات المشتركة عن طريق المنصة.
                </p>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  المادة الثالثة: مدة الاتفاقية
                </h2>
                <p className="leading-relaxed text-gray-600">
                  تدخل هذه الاتفاقية حيز النفاذ من تاريخ موافقة الطرف الثاني
                  عليها إلكترونياً (بالضغط على خانة الموافقة) عند إنشاء حسابه في
                  المنصة، ويجوز إنهاؤها في أي وقت بناءً على رغبة أحد الطرفين،
                  بشرط أن يخطر الطرف الراغب بالإنهاء الطرف الآخر بذلك كتابياً
                  قبل (15) يوماً من تاريخ الإنهاء، وبناءً على ذلك يجب على
                  الطرفين تسوية كافة المستحقات - إن وجدت - حتى تاريخ الإنهاء
                  خلال مدة لا تتجاوز (10) أيام من تاريخ الإنهاء.
                </p>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  المادة الرابعة: التزامات الطرف الأول
                </h2>
                <ol className="list-decimal space-y-2 pr-6 text-gray-600">
                  <li>
                    مساعدة ودعم الطرف الثاني في تفعيل حسابه في المنصة وتمكينه من
                    التقدم بطلب الخدمات.
                  </li>
                  <li>
                    إرسال الطلبات الواردة من الطرف الثاني للجهات المشتركة من
                    خلال المنصة أو أي وسيلة أخرى.
                  </li>
                  <li>
                    تشغيل وتطوير المنصة بشكل ملائم بهدف تحسين تجربة العملاء
                    وتنمية الطلبات بشكل مستمر.
                  </li>
                  <li>
                    تمكين الطرف الثاني من الاطلاع على التقارير التي تقدمها
                    المنصة واستعراض البيانات المرتبطة بها.
                  </li>
                  <li>
                    تدريب ممثل الطرف الثاني على آلية استخدام المنصة وتقديم الدعم
                    الفني اللازم له.
                  </li>
                  <li>
                    بذل الجهد لمعالجة أي عطل أو خلل فني في المنصة، ولا يتحمل
                    الطرف الأول أي تعويض عن أي ضرر ينشأ نتيجة لهذه الأعطال.
                  </li>
                </ol>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  المادة الخامسة: التزامات وإقرارات الطرف الثاني
                </h2>
                <ol className="list-decimal space-y-3 pr-6 text-gray-600">
                  <li>
                    تقديم وإدخال البيانات الصحيحة لطلبات الخدمات التي يتقدم بها،
                    وتزويد الطرف الأول بكافة المعلومات التي يطلبها في سبيل تفعيل
                    المنصة وإكمال متطلبات الاشتراك فيها.
                  </li>
                  <li>
                    متابعة المنصة بشكل دوري وفعال والتعامل مع أي طلبات تصل للطرف
                    الثاني عن طريق المنصة.
                  </li>
                  <li>
                    إبلاغ الطرف الأول في حال وجود أي خلل أو تقصير من قبل الجهات
                    المشتركة.
                  </li>
                  <li>
                    في حال وجود أي خلل أو تقصير في الخدمة المقدمة من الجهات
                    المشتركة فتكون الجهة مقدمة الخدمة مسؤولة وحدها عن التعويض
                    ومعالجة الخلل دون تحميل الطرف الأول أي مسؤولية بهذا الخصوص.
                  </li>
                  <li>
                    عدم التواصل مع الجهات المشتركة أو التعاقد معهم خارج المنصة
                    بأي حال من الأحوال، وفي حال إتمام التعاقد مع أي من الجهات
                    المشتركة خارج المنصة فيتحمل الطرف الثاني سداد كامل العمولة
                    التي يفرضها الطرف الأول على عملائه فور مطالبة الطرف الأول
                    بها.
                  </li>
                  <li>
                    الالتزام بكافة الأنظمة والقوانين المرتبطة بنشاط الطرف
                    الثاني، واستمرار سريان كافة تراخيصه طوال فترة سريان
                    الاتفاقية، وإبلاغ الطرف الأول فوراً في حال انتهاء صلاحية أي
                    من تراخيصه أو وجود نقص في المتطلبات النظامية لتقديم الطرف
                    الثاني لخدماته.
                  </li>
                  <li>
                    الموافقة على منح الطرف الأول صلاحية استخدام الأسماء
                    والعلامات التجارية المملوكة للطرف الثاني لأغراض دعائية
                    وإعلانية.
                  </li>
                  <li>
                    يقر ويوافق الطرف الثاني على أن جميع التعاملات المالية التي
                    تنشأ عن طريق المنصة بين الطرف الثاني والجهات المشتركة ستتم
                    تسويتها وسدادها بشكل مباشر بين الطرف الثاني والجهات
                    المشتركة، ولا يكون على الطرف الأول أي مسؤولية متعلقة بإدارة
                    التعاملات المالية بين الطرف الثاني والعملاء فيما عدا ما
                    يتعلق بالمستحقات المالية الخاصة بالطرف الأول.
                  </li>
                  <li>
                    يتحمل الطرف الثاني وحده أي مسؤولية أو مخالفة أو عقوبة تنتج
                    عن أي مخالفة مرتبطة بخدماته أو تراخيصه أو انتهاكه لحقوق
                    الغير، وفي حال لحق الطرف الأول أي ضرر واقع أو محتمل أو تكبد
                    أي تكاليف مالية أو غرامات من أي جهة فيحق له الرجوع على الطرف
                    الثاني ومطالبته بالتعويض عن ذلك.
                  </li>
                  <li>
                    يقر الطرف الثاني بأن مسؤولية الطرف الأول تنحصر في تمكينه من
                    استعمال المنصة، ولا تمتد لغير ذلك، ولا يجوز للطرف الثاني
                    مطالبة الطرف الأول بدفع أي مبلغ مالي، أو مطالبته بأي تعويضات
                    نتيجة إخلال الجهات المشتركة بالتزاماتها، أو نتيجة عدم دقة
                    المعلومات أو البيانات المقدمة من الجهات المشتركة، أو غير
                    ذلك.
                  </li>
                </ol>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  المادة السادسة: السداد والتحصيل
                </h2>
                <ol className="list-decimal space-y-3 pr-6 text-gray-600">
                  <li>
                    يستحق الطرف الأول عمولة قدرها (10%) عشرة بالمئة من قيمة
                    الطلبات التي تتم عبر المنصة.
                  </li>
                  <li>
                    يستحق الطرف الأول عمولته بمجرد إتمام التعاقد بين الطرف
                    الثاني وأحد الجهات المشتركة، وتسدد عمولة الطرف الأول مقدماً
                    وبشكل مستقل عن مبلغ الخدمات المقدمة من الجهات المشتركة، ولا
                    تكون هذه العمولة قابلة للاسترداد بأي حال من الأحوال.
                  </li>
                  <li>
                    التزم الطرف الثاني بسداد عمولة الطرف الأول فور استحقاقها على
                    الحساب البنكي الذي يحدده الطرف الأول.
                  </li>
                  <li>
                    يقوم الطرف الأول وبناءً على إجراءاته المحاسبية بتحديد آلية
                    الفوترة بين الطرفين وإصدار الفواتير الخاصة بعمولة الطرف
                    الأول.
                  </li>
                  <li>
                    يقر الطرفان أن الطرف الأول هو المرجع الوحيد في الحسابات
                    المالية وتتبع الطلبات واكتمالها من عدمه.
                  </li>
                  <li>
                    يتحمل كل طرف الضرائب المفروضة عليه بموجب الأنظمة المطبقة في
                    المملكة العربية السعودية.
                  </li>
                  <li>
                    يتحمل الطرف الثاني الرسوم البنكية وأي رسوم مدفوعات على
                    العمليات التي تتم عن طريق الدفع الإلكتروني والبطاقات
                    البنكية.
                  </li>
                </ol>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  المادة السابعة: حقوق الملكية الفكرية
                </h2>
                <p className="leading-relaxed text-gray-600">
                  يحتفظ كل طرف بكافة حقوق الملكية الفكرية والمنفعة في المواد
                  والمستندات المملوكة له أو المقدمة من قبله، ولا يجوز لأي طرف
                  استخدام أو اتخاذ أي إجراء بخصوص حقوق الملكية الفكرية التابعة
                  للطرف الآخر إلا بموجب موافقة خطية مسبقة من الطرف الآخر،
                  ويستثنى من ذلك حق الطرف الأول في استخدام الأسماء والعلامات
                  التجارية المملوكة للطرف الثاني لأغراض دعائية وإعلانية.
                </p>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  المادة الثامنة: سرية المعلومات
                </h2>
                <p className="leading-relaxed text-gray-600">
                  يلتزم الطرفين بالحفاظ على سرية ما ورد في هذه الاتفاقية وأي
                  معلومات، أو بيانات، أو وثائق، أو مستندات، أو مفاوضات، أو
                  تقارير متعلقة بهذه الاتفاقية أو بطرفي الاتفاقية سواء كانت
                  مكتوبة، أو شفهية، أو مرئية، أو مسموعة، وسواء تم تحصيلها أثناء،
                  أو بعد إبرام أو انتهاء الاتفاقية فتعتبر معلومات سرية، ولا يجوز
                  للطرف الآخر نشرها أو استخدامها لغير الأغراض المنصوص عليها في
                  هذه الاتفاقية بدون الحصول على موافقة الطرف الآخر المسبقة
                  خطياً، ويستثنى من ذلك ما كان امتثالاً للأنظمة والقوانين وذلك
                  بالحد المطلوب لعدم الإخلال بتلك الأنظمة وعلى أن يتم إخطار كل
                  طرف قبل الإفصاح عن ذلك، ويظل الالتزام بحكم هذه المادة سارياً
                  خلال مدة هذه الاتفاقية ولمدة سنتين ميلادية من تاريخ انتهائها
                  ما لم تنص الأنظمة واللوائح ذات العلاقة خلاف ذلك.
                </p>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  المادة التاسعة: الأنظمة واجبة التطبيق وحل النزاعات
                </h2>
                <p className="leading-relaxed text-gray-600">
                  تخضع هذه الاتفاقية لأنظمة المملكة العربية السعودية وتفسر وفقاً
                  لها، وفي حال حدوث أي نزاع بشأن تفسير أو تنفيذ أي من مواد هذه
                  الاتفاقية فيتم تسويته ودياً خلال ثلاثين (30) يوماً، وإذا تعذر
                  ذلك يُحال النزاع إلى الجهة القضائية المختصة في المملكة العربية
                  السعودية بمدينة الرياض.
                </p>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  المادة العاشرة: الأحكام العامة
                </h2>
                <ol className="list-decimal space-y-2 pr-6 text-gray-600">
                  <li>
                    في حال ظهر أي إخلال أو تقصير من أحد الطرفين في تنفيذ
                    التزاماته المحددة في الاتفاقية، فيخطره الطرف المتضرر بوقوع
                    ذلك الإخلال أو التقصير على أن يلتزم الطرف المقصر بتصحيح
                    تقصيره خلال (10) عشرة أيام من تاريخ الإخطار.
                  </li>
                  <li>
                    تكون المراسلات بين الطرفين بشأن تنفيذ الاتفاقية كتابية على
                    عنوان البريد الإلكتروني المسجل في حساب الطرف الثاني في
                    المنصة.
                  </li>
                  <li>
                    يكون التاريخ الميلادي هو التاريخ المعتبر لتنفيذ هذه
                    الاتفاقية.
                  </li>
                  <li>
                    لا يجوز تعديل هذه الاتفاقية أو تغييرها أو إضافة ملحقات إليها
                    إلا من قبل الطرف الأول، وتصبح التعديلات نافذة فور نشرها في
                    المنصة أو إخطار الطرف الثاني بها، ويعد استمرار الطرف الثاني
                    في استخدام المنصة بعد ذلك موافقة منه على تلك التعديلات.
                  </li>
                </ol>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  المادة الحادية عشرة: القوة القاهرة
                </h2>
                <ol className="list-decimal space-y-3 pr-6 text-gray-600">
                  <li>
                    لن يعتبر أي من الطرفين مخلاً بالتزاماته المترتبة على هذه
                    الاتفاقية إذا مُنع أو أُعيق من الوفاء بالتزاماته لأي سبب
                    خارج عن نطاق سيطرته المعقولة ويشمل ذلك على سبيل المثال لا
                    الحصر الزلازل أو الحوادث الطبيعية الأخرى أو الإضرابات العامة
                    أو انقطاع التيار الكهربائي أو نقص الإمدادات أو الأحداث
                    النووية أو الاضطرابات المدنية أو حالات الطوارئ العسكرية أو
                    الأعمال الإرهابية أو الإجراءات التشريعية أو القضائية أو
                    الأضرار الكيدية أو التقيد بأي قانون أو أمر أو نظام أو توجيه
                    صادر من جهة حكومية أو محكمة أو تدخلات السلطات العامة أو
                    الحوادث أو الحرائق أو الجوائح أو الفيضانات أو العواصف أو
                    الأحوال الجوية السيئة.
                  </li>
                  <li>
                    في حال عرقلة أو منع أي من الطرفين وفقاً لما سبق بيانه، يقوم
                    الطرف المعني بتوجيه إخطار بإيقاف التزاماته مؤقتاً وفقاً
                    للاتفاقية بأسرع فرصة ممكنة إلى الطرف الآخر يبيّن تاريخ ومدى
                    الإيقاف وسببه، فالامتناع عن توجيه ذلك الإخطار يُسقط حقوق ذلك
                    الشخص في التمسك بضرورة الإيقاف وأي طرف يتم تعليق التزاماته
                    كما ذكر أعلاه يجب أن يستأنف أداء تلك الالتزامات بأسرع فرصة
                    ممكنة بعد زوال السبب ومن ثم إخطار الطرف الآخر بذلك.
                  </li>
                  <li>
                    يبذل كل طرف قصارى جهده لإزالة أحداث القوة القاهرة (إن وجدت)
                    في أقصر وقت ممكن وتخفيف الآثار السلبية على أدائه قدر
                    الإمكان.
                  </li>
                  <li>
                    يتم تعليق التزامات كل طرف بموجب هذه الاتفاقية ويتوقف التزامه
                    بالوفاء بها طوال مدة تواجد الحدث وحتى زواله.
                  </li>
                </ol>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  المادة الثانية عشرة: التفاهم الكامل
                </h2>
                <p className="leading-relaxed text-gray-600">
                  تمثل هذه الاتفاقية كامل ما تم التفاهم عليه بين الطرفين فيما
                  يتعلق بموضوعها، وتنسخ أي مفاهمات أو اتفاقيات مبرمة سابقاً بين
                  الطرفين بشأن موضوعها.
                </p>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  إقرار وموافقة
                </h2>
                <p className="leading-relaxed font-semibold text-gray-700">
                  بالضغط على خانة الموافقة عند إنشاء الحساب في المنصة، يقر الطرف
                  الثاني بأنه قرأ هذه الاتفاقية وفهم جميع بنودها ووافق عليها،
                  وتعد هذه الموافقة الإلكترونية نافذة وملزمة للطرفين دون الحاجة
                  إلى أي توقيع خطي.
                </p>
              </div>
            </div>
          </section>

          <hr className="my-12 border-gray-200" />

          <section dir="ltr" className="mb-16">
            <h1 className="mb-4 text-2xl font-bold text-gray-900">
              Client Subscription Agreement to the Platform
            </h1>
            <p className="mb-8 leading-relaxed text-gray-500 italic">
              The following is an English translation of the Arabic agreement
              above. In the event of any discrepancy between the Arabic text and
              this English translation, the Arabic text shall prevail.
            </p>

            <div className="space-y-8">
              <div>
                <p className="mb-4 leading-relaxed text-gray-600">
                  By the grace of Allah Almighty, this Agreement has been
                  entered into by and between:
                </p>
                <p className="mb-2 leading-relaxed text-gray-600">
                  <strong>First Party:</strong> MedHub Platform (hereinafter
                  referred to as the "First Party").
                </p>
                <p className="mb-2 leading-relaxed text-gray-600">
                  <strong>Second Party:</strong> The client who creates an
                  account on the Platform and accepts this Agreement
                  electronically (hereinafter referred to as the "Second
                  Party").
                </p>
                <p className="leading-relaxed text-gray-600">
                  (Collectively referred to hereinafter as the "Parties" and
                  individually as a "Party".)
                </p>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Definitions
                </h2>
                <p className="mb-4 leading-relaxed text-gray-600">
                  The words and expressions used in this Agreement shall have
                  the meanings assigned to each of them below, unless the
                  context requires otherwise:
                </p>
                <ul className="list-disc space-y-3 pl-6 text-gray-600">
                  <li>
                    <strong>Agreement:</strong> This Agreement together with all
                    schedules and annexes attached hereto.
                  </li>
                  <li>
                    <strong>Platform:</strong> The MedHub platform, an
                    electronic platform that enables Clients to request
                    ambulance services and related services from the
                    Participating Entities.
                  </li>
                  <li>
                    <strong>Clients:</strong> The entities or persons benefiting
                    from the Platform who submit service requests through it.
                  </li>
                  <li>
                    <strong>Participating Entities:</strong> The service
                    provider subscribed to the Platform to provide its services
                    through it.
                  </li>
                </ul>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Preamble
                </h2>
                <p className="mb-4 leading-relaxed text-gray-600">
                  Whereas the First Party operates in the field of health and
                  digital solutions and services, and whereas the First Party
                  owns the Platform, which specializes in offering ambulance
                  services and related services to the Clients;
                </p>
                <p className="leading-relaxed text-gray-600">
                  And whereas the Second Party wishes to subscribe to the
                  Platform in order to request the services of the Participating
                  Entities, the Parties have agreed to enter into this Agreement
                  as follows:
                </p>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Article One: Effect of the Preamble
                </h2>
                <p className="leading-relaxed text-gray-600">
                  The foregoing preamble constitutes an integral part of this
                  Agreement and shall be read and construed together with it.
                </p>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Article Two: Purpose of the Agreement
                </h2>
                <p className="leading-relaxed text-gray-600">
                  This Agreement aims to enable the Second Party to register on
                  the Platform as a client in order to be able to request the
                  services of the Participating Entities through the Platform.
                </p>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Article Three: Term of the Agreement
                </h2>
                <p className="leading-relaxed text-gray-600">
                  This Agreement enters into force on the date on which the
                  Second Party accepts it electronically (by ticking the
                  acceptance checkbox) upon creating its account on the
                  Platform. It may be terminated at any time at the request of
                  either Party, provided that the Party wishing to terminate
                  notifies the other Party thereof in writing fifteen (15) days
                  prior to the termination date. Accordingly, the Parties shall
                  settle all outstanding dues, if any, up to the termination
                  date within a period not exceeding ten (10) days from the
                  termination date.
                </p>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Article Four: Obligations of the First Party
                </h2>
                <ol className="list-decimal space-y-2 pl-6 text-gray-600">
                  <li>
                    Assisting and supporting the Second Party in activating its
                    account on the Platform and enabling it to submit service
                    requests.
                  </li>
                  <li>
                    Forwarding the requests received from the Second Party to
                    the Participating Entities through the Platform or any other
                    means.
                  </li>
                  <li>
                    Operating and developing the Platform appropriately with the
                    aim of improving the client experience and continuously
                    growing requests.
                  </li>
                  <li>
                    Enabling the Second Party to access the reports provided by
                    the Platform and to review the data associated therewith.
                  </li>
                  <li>
                    Training the Second Party's representative on the mechanism
                    of using the Platform and providing it with the necessary
                    technical support.
                  </li>
                  <li>
                    Exerting effort to remedy any malfunction or technical
                    defect in the Platform; the First Party shall not bear any
                    compensation for any damage arising as a result of such
                    malfunctions.
                  </li>
                </ol>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Article Five: Obligations and Acknowledgments of the Second
                  Party
                </h2>
                <ol className="list-decimal space-y-3 pl-6 text-gray-600">
                  <li>
                    Providing and entering accurate data for the service
                    requests it submits, and providing the First Party with all
                    information it requests for the purpose of activating the
                    Platform and completing the subscription requirements.
                  </li>
                  <li>
                    Monitoring the Platform regularly and effectively and
                    handling any requests received by the Second Party through
                    the Platform.
                  </li>
                  <li>
                    Notifying the First Party in the event of any defect or
                    shortcoming on the part of the Participating Entities.
                  </li>
                  <li>
                    In the event of any defect or shortcoming in the service
                    provided by the Participating Entities, the entity providing
                    the service shall be solely responsible for compensation and
                    for remedying the defect, without holding the First Party
                    liable in this regard.
                  </li>
                  <li>
                    Not communicating with the Participating Entities or
                    contracting with them outside the Platform under any
                    circumstances. If a contract is concluded with any of the
                    Participating Entities outside the Platform, the Second
                    Party shall pay the full commission imposed by the First
                    Party on its clients immediately upon the First Party's
                    demand.
                  </li>
                  <li>
                    Complying with all laws and regulations related to the
                    Second Party's activity, maintaining the validity of all its
                    licenses throughout the term of the Agreement, and
                    immediately notifying the First Party in the event of the
                    expiry of any of its licenses or of any deficiency in the
                    regulatory requirements for the Second Party to provide its
                    services.
                  </li>
                  <li>
                    Agreeing to grant the First Party the right to use the names
                    and trademarks owned by the Second Party for promotional and
                    advertising purposes.
                  </li>
                  <li>
                    The Second Party acknowledges and agrees that all financial
                    transactions arising through the Platform between the Second
                    Party and the Participating Entities shall be settled and
                    paid directly between the Second Party and the Participating
                    Entities, and the First Party shall bear no responsibility
                    related to managing the financial transactions between the
                    Second Party and the Clients, except with respect to the
                    financial dues owed to the First Party.
                  </li>
                  <li>
                    The Second Party alone shall bear any liability, violation,
                    or penalty resulting from any violation related to its
                    services, its licenses, or its infringement of the rights of
                    third parties. If the First Party suffers any actual or
                    potential damage, or incurs any financial costs or fines
                    from any authority, it shall be entitled to have recourse
                    against the Second Party and to claim compensation therefor.
                  </li>
                  <li>
                    The Second Party acknowledges that the First Party's
                    responsibility is limited to enabling it to use the Platform
                    and does not extend beyond that. The Second Party may not
                    claim from the First Party the payment of any monetary
                    amount, nor claim any compensation as a result of the
                    Participating Entities' breach of their obligations, or as a
                    result of the inaccuracy of the information or data provided
                    by the Participating Entities, or otherwise.
                  </li>
                </ol>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Article Six: Payment and Collection
                </h2>
                <ol className="list-decimal space-y-3 pl-6 text-gray-600">
                  <li>
                    The First Party is entitled to a commission of ten percent
                    (10%) of the value of the requests completed through the
                    Platform.
                  </li>
                  <li>
                    The First Party's commission becomes due upon the conclusion
                    of the contract between the Second Party and one of the
                    Participating Entities. The First Party's commission shall
                    be paid in advance and independently of the amount of the
                    services provided by the Participating Entities, and this
                    commission shall not be refundable under any circumstances.
                  </li>
                  <li>
                    The Second Party undertakes to pay the First Party's
                    commission immediately upon its becoming due, to the bank
                    account designated by the First Party.
                  </li>
                  <li>
                    The First Party shall, in accordance with its accounting
                    procedures, determine the invoicing mechanism between the
                    Parties and issue the invoices for the First Party's
                    commission.
                  </li>
                  <li>
                    The Parties acknowledge that the First Party is the sole
                    reference with respect to the financial accounts and the
                    tracking of requests and whether or not they have been
                    completed.
                  </li>
                  <li>
                    Each Party shall bear the taxes imposed on it under the laws
                    applicable in the Kingdom of Saudi Arabia.
                  </li>
                  <li>
                    The Second Party shall bear the bank fees and any payment
                    fees on transactions conducted through electronic payment
                    and bank cards.
                  </li>
                </ol>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Article Seven: Intellectual Property Rights
                </h2>
                <p className="leading-relaxed text-gray-600">
                  Each Party retains all intellectual property rights and
                  interests in the materials and documents owned or provided by
                  it. Neither Party may use, or take any action with respect to,
                  the intellectual property rights of the other Party except
                  with the prior written consent of the other Party, with the
                  exception of the First Party's right to use the names and
                  trademarks owned by the Second Party for promotional and
                  advertising purposes.
                </p>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Article Eight: Confidentiality of Information
                </h2>
                <p className="leading-relaxed text-gray-600">
                  The Parties shall maintain the confidentiality of the contents
                  of this Agreement and of any information, data, documents,
                  records, negotiations, or reports related to this Agreement or
                  to the Parties hereto, whether written, verbal, visual, or
                  audio, and whether obtained during or after the conclusion or
                  expiry of the Agreement; all such information shall be deemed
                  confidential. Neither Party may publish or use such
                  information for purposes other than those stipulated in this
                  Agreement without obtaining the prior written consent of the
                  other Party, except for disclosures made in compliance with
                  applicable laws and regulations, to the extent required to
                  avoid breaching such laws, provided that each Party is
                  notified prior to such disclosure. The obligation under this
                  Article shall remain in effect throughout the term of this
                  Agreement and for two (2) calendar years from its expiry date,
                  unless the relevant laws and regulations provide otherwise.
                </p>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Article Nine: Governing Law and Dispute Resolution
                </h2>
                <p className="leading-relaxed text-gray-600">
                  This Agreement is governed by, and shall be construed in
                  accordance with, the laws of the Kingdom of Saudi Arabia. In
                  the event of any dispute concerning the interpretation or
                  implementation of any article of this Agreement, it shall be
                  settled amicably within thirty (30) days; if this is not
                  possible, the dispute shall be referred to the competent
                  judicial authority in the Kingdom of Saudi Arabia in the city
                  of Riyadh.
                </p>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Article Ten: General Provisions
                </h2>
                <ol className="list-decimal space-y-2 pl-6 text-gray-600">
                  <li>
                    In the event of any breach or default by either Party in the
                    performance of its obligations specified in the Agreement,
                    the aggrieved Party shall notify the defaulting Party of the
                    occurrence of such breach or default, and the defaulting
                    Party shall remedy its default within ten (10) days from the
                    date of notification.
                  </li>
                  <li>
                    Correspondence between the Parties regarding the
                    implementation of the Agreement shall be in writing to the
                    email address registered in the Second Party's account on
                    the Platform.
                  </li>
                  <li>
                    The Gregorian calendar shall be the calendar applicable for
                    the implementation of this Agreement.
                  </li>
                  <li>
                    This Agreement may not be amended, changed, or supplemented
                    except by the First Party. Amendments shall become effective
                    upon their publication on the Platform or upon notification
                    to the Second Party, and the Second Party's continued use of
                    the Platform thereafter shall constitute its acceptance of
                    such amendments.
                  </li>
                </ol>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Article Eleven: Force Majeure
                </h2>
                <ol className="list-decimal space-y-3 pl-6 text-gray-600">
                  <li>
                    Neither Party shall be deemed in breach of its obligations
                    under this Agreement if it is prevented or hindered from
                    fulfilling its obligations for any reason beyond its
                    reasonable control, including, without limitation,
                    earthquakes or other natural disasters, general strikes,
                    power outages, supply shortages, nuclear events, civil
                    disturbances, states of military emergency, acts of
                    terrorism, legislative or judicial actions, malicious
                    damage, compliance with any law, order, regulation, or
                    directive issued by a governmental authority or court,
                    interventions of public authorities, accidents, fires,
                    pandemics, floods, storms, or severe weather conditions.
                  </li>
                  <li>
                    If either Party is hindered or prevented as described above,
                    the affected Party shall, at the earliest possible
                    opportunity, give notice to the other Party of the temporary
                    suspension of its obligations under the Agreement,
                    indicating the date, extent, and cause of the suspension.
                    Failure to give such notice shall forfeit that Party's right
                    to invoke the necessity of the suspension. Any Party whose
                    obligations are suspended as mentioned above shall resume
                    the performance of those obligations at the earliest
                    possible opportunity after the cause ceases, and shall then
                    notify the other Party accordingly.
                  </li>
                  <li>
                    Each Party shall use its best efforts to remove the force
                    majeure events (if any) in the shortest possible time and to
                    mitigate the negative effects on its performance to the
                    extent possible.
                  </li>
                  <li>
                    Each Party's obligations under this Agreement shall be
                    suspended, and its obligation to fulfill them shall cease,
                    throughout the duration of the event and until it ceases.
                  </li>
                </ol>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Article Twelve: Entire Agreement
                </h2>
                <p className="leading-relaxed text-gray-600">
                  This Agreement constitutes the entire understanding reached
                  between the Parties with respect to its subject matter and
                  supersedes any prior understandings or agreements previously
                  concluded between the Parties in respect thereof.
                </p>
              </div>

              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  Acknowledgment and Consent
                </h2>
                <p className="leading-relaxed font-semibold text-gray-700">
                  By ticking the acceptance checkbox upon creating the account
                  on the Platform, the Second Party acknowledges that it has
                  read this Agreement, understood all of its terms, and agreed
                  thereto. This electronic acceptance shall be valid and binding
                  on the Parties without the need for any handwritten signature.
                </p>
              </div>
            </div>
          </section>
        </motion.div>
      </div>
    </div>
  );
}
